import { Component, ReactNode } from 'react';

interface Props {
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class TemplateErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    console.error('Template-Render fehlgeschlagen, falle auf classic zurück:', error);
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
